import defaultLayout from '../../../layouts/default'
import homeLayout from '../../../layouts/home'
export default {
  path: 'payment',
  component: defaultLayout,
  children: [
    {
      path: '',
      component: homeLayout,
      children: [
        {
          path: 'price',
          component: () => import('./price'),
          meta: {
            activeMenu: 'price'
          }
        },
        {
          path: 'agreement',
          component: () => import('./agreement'),
          meta: {
            activeMenu: 'price'
          }
        }
      ]
    },
    // {
    //   path: 'price',
    //   component: () => import('./price'),
    //   meta: {
    //     activeMenu: 'price'
    //   }
    // },
    {
      path: 'buy',
      component: () => import('./buy'),
      meta: {
        activeMenu: 'price',
        auth: true
      },
      beforeRouteEnter(to, from, next) {
        console.log({
          to,
          from,
          next
        })
      }
    },
    {
      path: 'renew',
      component: () => import('./renew'),
      meta: {
        activeMenu: 'price',
        auth: true
      }
    },
    {
      path: 'upgrade',
      component: () => import('./upgrade'),
      meta: {
        activeMenu: 'price',
        auth: true
      }
    },
    {
      path: 'incrcard',
      component: () => import('./incrcard'),
      meta: {
        activeMenu: 'price',
        auth: true
      }
    },
    {
      path: 'incruser',
      component: () => import('./incruser'),
      meta: {
        activeMenu: 'price',
        auth: true
      }
    },
    {
      path: 'success',
      component: () => import('./success'),
      meta: {
        activeMenu: 'price'
      }
    },
    {
      path: 'paynotify',
      component: () => import('./paynotify'),
      meta: {
        activeMenu: 'price'
      }
    },
    {
      path: 'paycancel',
      component: () => import('./paycancel'),
      meta: {
        activeMenu: 'price'
      }
    },
    {
      path: 'login',
      component: () => import('./login'),
      meta: {
        activeMenu: 'price',
        auth: false
      }
    },
    {
      path: 'bill',
      component: () => import('./bill'),
      meta: {
        activeMenu: 'price',
        auth: false
      }
    }
  ]
}
